export default __webpack_public_path__ + "static/media/restaurant-1-lqMAX.072388ac.jpg";